var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from '@mui/material';
export var SmartTooltip = function (_a) {
    var enabledTitle = _a.enabledTitle, disabledTitle = _a.disabledTitle, _b = _a.tooltipSide, tooltipSide = _b === void 0 ? 'top' : _b, enabled = _a.enabled, children = _a.children;
    return (_jsx(Tooltip, __assign({ title: enabled ? enabledTitle : disabledTitle, placement: tooltipSide }, { children: _jsx("span", { children: children }) })));
};
